import AppDispatcher from '../dispatcher/AppDispatcher';
import RemixerConstants from '../constants/RemixerConstants';

/** @module PixabayServerActionsCreator
 * @requires AppDispatcher
 * @requires RemixerConstants
 */
export default {
	receiveSearchYoutube(query, page, response) {
		AppDispatcher.dispatch({
			actionType: RemixerConstants.RECEIVE_SEARCH_YOUTUBE,
			query,
			page,
			response
		});
	},
	receiveSearchYoutubeFails(query, page, response) {
		AppDispatcher.dispatch({
			actionType: RemixerConstants.RECEIVE_SEARCH_YOUTUBE_FAILS,
			query,
			page,
			response
		});
	}
};
